import {
    OrderQuery as SourceOrderQuery
} from 'SourceQuery/Order.query';
import { Field } from 'Util/Query';

/** @namespace Elganso/Query/Order/Query */
export class OrderQuery extends SourceOrderQuery {
    _getOrderItemProductsFields() {
        return [
            'product_url_key',
            'quantity_ordered',
            'quantity_shipped',
            'quantity_refunded',
            'quantity_canceled',
            'image',
            'preorder',
            'product_price_incl_tax',
            this._getOrderProductEnteredOptionsField(),
            this._getOrderProductSelectedOptionsField(),
            this._getOrderProductRowSubtotalField(),
            ...this._getBaseOrderItemProductsFields()
        ];
    }

    _getOrderItemsFields(isSingleOrder) {
        const basicFields = [
            'id',
            'increment_id',
            'order_date',
            'status',
            'can_reorder',
            'rss_link',
            this._getOrderAdditionalDataField(),
            this._getOrderItemTotalField()
        ];

        if (isSingleOrder) {
            return [...basicFields, ...this._getSingleOrderFields()];
        }

        return basicFields;
    }

    _getOrderAdditionalDataField() {
        return new Field('additional_data')
            .addFieldList(this._getOrderAdditionalDataFields());
    }

    _getOrderAdditionalDataFields() {
        return [
            'total_qty_ordered',
            'delivery_date',
            'order_item_images',
            'order_product_url',
            'order_item_prices',
            'order_item_names',
            'order_shipments'
        ];
    }

    setTrazabilidadPedidoMutation(options) {
        return new Field('setTrazabilidadPedido')
            .addArgument('input', 'TrazabilidadPedidoInput!', options)
            .addFieldList(this.setTrazabilidadPedidoFields());
    }

    setTrazabilidadPedidoFields() {
        return [
            'result'
        ];
    }
}

export default new OrderQuery();
